import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, public auth: AuthenticationService) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if (!this.auth.isAuthenticated()) {
            this.router.navigate(['/login']);
            return false;
        }
        else {
            //if (this.auth.needPasswordReset()) {
               // this.router.navigate(['/account/changepassword']);
                return true;
            //} 
        }
        //return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/guard/auth.guard.ts